import { SearchInput } from 'components/search-input';

import { useEntityListContext } from './EntityListContext';

export function EntityListSearch() {
  const { queryString, setQueryString } = useEntityListContext();

  return <SearchInput value={queryString} aria-label="Search" onSearch={setQueryString} />;
}
